<template>
   <!-- <SplashScreen v-if="showSplash" /> -->
  <LanguageSwitcher />
  <router-view/>


</template>

<script>
import { ref, onMounted } from 'vue'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
// import SplashScreen from '@/components/SplashScreen.vue'


const showSplash = ref(true)

onMounted(() => {
  setTimeout(() => {
    showSplash.value = false
  }, 5000)
})
// Stocke l'élément actif

// Fonction pour changer l'élément actif

export default {
  components: {
    LanguageSwitcher
  },
  mounted() {
    // Stocker l'élément avec la classe .my-class
    this.link = document.querySelector(".link");
  },
  methods: {
    navbar(){
      this.link.classList.add('active')
    },
    navRemove(){
      this.link.classList.remove('active')
    }
  }
};
</script>

<style>
*,
::before,
::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  scroll-behavior: smooth;
  background: #14130e;
}

html::-webkit-scrollbar {
  width: 12px;
}

html::-webkit-scrollbar-track {
  background: #fff;
}

html::-webkit-scrollbar-thumb {
  background: linear-gradient(transparent, #8bbf30);
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
}

/* h1 {
  color: #8bbf30;
  font-family: Montserrat, Arial, Helvetica, sans-serif;
   font-size: 2em; 
  
  white-space: nowrap;
} */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  display: flex;
  flex-direction: column;
  width:100%;
  height: auto;
}

</style>
